import styled from "styled-components";

const ItemIngredientsPanelActionStyled = styled.div`

`;

export default ItemIngredientsPanelActionStyled;